import { useState } from 'react';
import { TextField, NumberField } from '@flos/react-ui';
import useAppState from '../../../state/appState';
import { ElementValue } from '../../../types/element-values';
import { FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { FieldValueType, contentElementId, validationText } from './util';
import isNotEmpty from '../../../validators/is-not-empty';

const fieldLabel = {
    bankName: 'Bankens navn',
    cardName: 'Hvilket navn står der på kortet?',
    cardNumber: 'Kortnummer'
};

const Bank = () => {
    const { Bank: BankElement } = contentElementId;
    const { bankNameId, nameOnCardId, cardNumberId } = BankElement;

    const formValues = useAppState((state) => state.formValues);
    const setFormValue = useAppState((state) => state.setFormValue);

    const bankName = Bank.getValueOrDefault(formValues, bankNameId);
    const cardName = Bank.getValueOrDefault(formValues, nameOnCardId);
    const cardNumber = Bank.getValueOrDefault(formValues, cardNumberId);

    const [fieldHasHadFocusAtLeastOnce, setFieldHasHadFocusAtLeastOnce] = useState<
        Record<keyof typeof fieldLabel, boolean>
    >({
        bankName: false,
        cardName: false,
        cardNumber: false
    });

    return (
        <div className="u-spacing-stack-m other-company">
            <TextField
                required
                value={bankName.value}
                label={fieldLabel.bankName}
                errorText={validationText}
                isValid={fieldHasHadFocusAtLeastOnce.bankName ? isNotEmpty(bankName.value) : undefined}
                onFocus={() => setFieldHasHadFocusAtLeastOnce((field) => ({ ...field, bankName: true }))}
                onChange={({ target: { value } }) => {
                    setFormValue(bankNameId, { label: fieldLabel.bankName, value });
                }}
            />
            <TextField
                required
                value={cardName.value}
                label={fieldLabel.cardName}
                errorText={validationText}
                isValid={fieldHasHadFocusAtLeastOnce.cardName ? isNotEmpty(cardName.value) : undefined}
                onFocus={() => setFieldHasHadFocusAtLeastOnce((field) => ({ ...field, cardName: true }))}
                onChange={({ target: { value } }) => {
                    setFormValue(nameOnCardId, { label: fieldLabel.cardName, value });
                }}
            />
            <NumberField
                required
                value={cardNumber.value}
                errorText={validationText}
                isValid={fieldHasHadFocusAtLeastOnce.cardNumber ? isNotEmpty(cardNumber.value) : undefined}
                onFocus={() => setFieldHasHadFocusAtLeastOnce((field) => ({ ...field, cardNumber: true }))}
                onChange={({ target: { value } }) => {
                    setFormValue(cardNumberId, { label: fieldLabel.cardNumber, value });
                }}
                id={cardNumberId}
                key={cardNumberId}
                label={fieldLabel.cardNumber}
                data-testid="numberfield"
            />
        </div>
    );
};

Bank.getValue = (formValues: FormValues, elementId: string): ElementValue => {
    const value = formValues[elementId];
    return value;
};

Bank.getValueOrDefault = (formValues: FormValues, elementId: string) => {
    const value: FieldValueType | undefined = Bank.getValue(formValues, elementId);

    if (value === undefined) {
        return { label: '', value: '' };
    }
    return value;
};

export default Bank;
